export default {"src":"/_next/static/media/bg_mint.a12442ae.svg","height":605,"width":2200,"blurWidth":0,"blurHeight":0};